// EmployeeTimeEntry.jsx

import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect, useState } from 'react';
import { Typography } from "@mui/material";
import { Container, Row } from "react-bootstrap";
import Spinner from "../components/Spinner";
import EmployeeTimeEntryButtons from "./EmployeeTimeEntryButtons";
import { login, logout} from "../features/auth/authSlice";
import {getUserTimeEntries, updateTimeEntry, createTimeEntry} from "../features/timeentries/timeentrySlice.jsx";
import EmployeeStatusBadge from "./EmployeeStatusBadge";
import EmployeeAvatar from "./EmployeeAvatar";


 const EmployeeTimeEntry = ({employee, entries, handleSetStatus, newstatus}) => {
   const [ShowButtons, setShowButtons ] = useState(true);
   const { UpdateEntryisSuccess,CreateEntryisSuccess } = useSelector((state) => state.entries);
   const { user, isSuccessAuth, isErrorAuth } = useSelector((state) => state.auth);
   const dispatch = useDispatch();
   
   const handleSetEntryButtonShow = (show) => {
     setShowButtons(show);
    };

  function getEmployeeStatus(entries) {

    if (entries.count > 0) {
      const currentEntry = entries.results.filter(result => result.end_time === null);
      switch (currentEntry.length) {
        case 0:
          return { clockedIn: false, onPause: false, entryId: null, paused_time:null, secondss_paused:null};
        case 1:
          return currentEntry[0].pause_time === null ?
            { clockedIn: true, onPause: false, entryId: currentEntry[0].id, paused_time:null, secondss_paused:null } :
            { clockedIn: true, onPause: true, entryId: currentEntry[0].id, paused_time:currentEntry[0].pause_time, secondss_paused: currentEntry[0].seconds_paused };
        default:
          return { clockedIn: true, onPause: true, entryId: currentEntry[0].id, paused_time:currentEntry[0].pause_time, secondss_paused:null };
      }
    } else {
      return { clockedIn: false, onPause: false, entryId: null, paused_time:null, secondss_paused:null };
    }
  }

  const employeeButtonChoice = getEmployeeStatus(entries);
  // console.log('status from TimeEntry: '+employee.status);
  return (
    <Container>
      { ShowButtons === true ? 
        <EmployeeTimeEntryButtons
          employeeButtonChoice={employeeButtonChoice}
          employee={employee}
          handleSetEntryButtonShow={handleSetEntryButtonShow}
          handleSetStatus={handleSetStatus}
        />
      :null
      }
    </Container>
  );
};

export default EmployeeTimeEntry;

